<template>
    <div class="Details">
      
      <div class="columns">
          
          <div class="column">
            
          
       <section ref="element">
       
          <div class="x">
            
             <b-skeleton size="is-large" height="80px" :active="!documents"></b-skeleton>
             <b-skeleton size="is-large" height="160px" :active="!documents"></b-skeleton>
             <div class="box" v-if="documents">

                <b-field label="Dataset">
                <b-select
                    @input="changeFilter"
                    v-model="filterByDataset"
                    placeholder="Filter by dataset file"
                    expanded>
                    <option value="any">Any</option>
                    <option
                        v-for="dataset of projectDatasets"
                        :value="dataset.id"
                        >
                        {{ dataset.filename }}
                    </option>
                </b-select>
            </b-field>
            
                <b-table 
                   :data="documents"
                   :per-page="singleMode?1:30"
                   :total="documents.length"
                   :pagination-position="singleMode?'bottom':'both'"
                   paginated
                   pagination-size="is-small"
                   :loading="!documents"
                   >
                   <template #top-left>
                          <b>Records</b>: {{ documents.length }}
                    </template>
                    
                    <b-table-column width="100" field="text" label="" v-slot="props">
                      {{  props.row.text }}
                    </b-table-column>
                    <b-table-column width="100" field="label" label="" v-slot="props">
                      {{  props.row.label }}
                    </b-table-column>
                   <template #bottom-left v-if="singleMode">
                          <b>Annotated records: {{ documents.filter( i => i.label !== false).length }} out of {{ documents.length }}</b>
                   </template>
                    
                </b-table>
                <hr>
             </div>
          </div>
       </section>
       
          </div>
      </div>
  
       <b-modal
            v-model="isModalLabelsOpen"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Model"
            aria-modal
            scroll="keep">
            <template #default="props">
              <ModalLabels @close="props.close" :labelingMode="true" :project="project" :projectDocuments="projectDocuments"></ModalLabels>
            </template>
        </b-modal>
  
    </div>
  </template>
  <script>
    import TrainModel from '@/components/TrainModel.vue'
    import TrainRuns from '@/components/TrainRuns.vue'
    import ModalLabels from '@/components/ModalLabels.vue'
    import Annotation from '@/components/AnnotationTemplate.vue'
    import fuzzysort from 'fuzzysort'
    import { mapState } from 'vuex';
  
    export default {
         props: ["project", "projectModels", "projectDatasets", "currentUser"],
         name: "Train",
         data: function() {
        return {
            perPage: 10,
            pageInput: 1,
            singleMode: false,
            isMounting: true,
            checkedRows: [],
            isModalLabelsOpen: false,
            viewFilter: (this.$route.query.f == 'errors')?'issues':'all',
            viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
            versions: false,
            checkboxCustom: [],
            selected: {text: false, label: 'unlabeled'},
            newLabel: false,
            selectedVersion: 'v1',
            animated: true,
            candidateLabels: [(1,1),(2,3)],
            isModalTrainCreateOpen: false,
            labelKeys: [],
            options: {
            
            },
            total: 0,
            predicted: 'any',
            given: 'any',
            search: null,
            sortBy: null,
            isLoading: true,
            filterByDataset: 'any',
            uploadList: [],
            labelsViewMin: 8
        }},
        components: {
          "modal-train": TrainModel,
          "train-runs": TrainRuns,
          ModalLabels,
          Annotation
        },
        computed: {
         rows() {
              return this.$store.getters.rowsByDataset(this.project.datasetId)
          },
         documents() {
          return this.sortDocuments(
                this.fuzzySearchFilter(
                  this.$store.getters.rowsByDataset(this.project.datasetId).filter( 
                    item => (
                      this.givenFilter(item) && this.predictedFilter(item) && this.searchFilter(item) && this.datasetFilter(item)
                    )
                  )
                )
              )
          } 
         },
         filters: {
          dateFormat: function (value) {
              // from timestamp to date
              // parse to int
              value = parseInt(value)
              return new Date(value).toLocaleString('en-US', 
              { timeZone: 'UTC', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
          }
         },
         methods: {
          triggerTraining(){
              this.$store.dispatch("triggerTraining",
                      {projectId: this.project.id}
              )
          },
          deleteDocument(row){
            let rowId = row.id
            this.$store.dispatch('deleteRow', row.id)
  
            this.rows = this.$store.getters.removeRow(rowId)
            this.triggerTraining()
            
          },
          checkLabelDist(){
            let labelsOk = 0
            for (label of this.project.labels){
              if(this.projectDocuments.filter( item => item.label == label.label).length >= 10){
                labelsOk += 1
              }
            }
            
            if (labelsOk == this.project.labels.length){
              console.log("ok")
            }
          },
          changeOutput(row){
            
              const rowToUpdate = {
                  datasetId: this.project.datasetId,
                  createdAt: row.createdAt,
                  id: row.id,
                  label: row.label,
                  text: row.text
              }
    
              // must have datasetId, text (or label)
              this.$store.dispatch('updateRow', rowToUpdate)
              this.triggerTraining()
          },
          changeFilter(){
    
            this.documents = this.getDocuments()
          },
          getLabels(){
            return (this.project.labels?this.project.labels:[])
          },
          changeLabel(row){
  
              const current_label = this.project.labels.filter( item => item.label == row.label)[0]
  
              const rowToUpdate = {
                  datasetId: this.project.datasetId,
                  id: row.id,
                  text: row.text,
                  label: row.label,
                  label: current_label.label,
                  createdAt: row.createdAt,
              }
  
              // must have datasetId, text (or label)
              this.$store.dispatch('updateRow', rowToUpdate)
              this.triggerTraining()
          },
          predictedFilter(item){
            
            if (this.predicted == 'not'){
              return item.prediction == undefined || item.prediction === false || item.prediction == null || item.prediction == NaN
            } else if (this.predicted == 'agrees'){
              return item.prediction === item.label && item.label !== false && (item.prediction != undefined && item.prediction !== false && item.prediction != null)
            } else if (this.predicted == 'disagrees'){
              return item.prediction != item.label && item.label !== false && (item.prediction != undefined && item.prediction !== false && item.prediction != null)
            }  else if (this.predicted != 'any'){
              return item.prediction === this.predicted
            } else if (this.predicted == 'any'){
              return true
            } else {
              return false
            }
          },
          givenFilter(item){
            
            if (this.given === 'unlabeled'){
              return item.label === false || item.label === 'False' || item.label === undefined
            } else if (this.given != 'any'){
              return item.label === this.given
            } else if (this.given === 'any'){
              return true
            } else {
              return false
            }
          },
          searchFilter(item){
            return true;
            if (this.search != null){
              return item.text.toLowerCase().includes(this.search.toLowerCase())
            } else {
              return true
            }
          },
          fuzzySearchFilter(docs){
             const options = {
                 key: 'text',
                 limit: 100, // don't return more results than you need!
                 threshold: -10000, // don't return bad results
              }
              if (this.search != null && this.search != ""){
                 return fuzzysort.go(this.search, docs, options).flatMap(r => r.obj);
              } else {
                 return docs
              }
          },
          datasetFilter(item){
            if (this.filterByDataset !== 'any'){
              return item.uploadId === this.filterByDataset
            } else {
              return true
            }
          },
          sortDocuments(doc){
            if (this.sortBy == 'high_score'){
              return doc.sort((a,b) => b.confidence - a.confidence);
            } else if (this.sortBy == 'low_score'){
              return doc.sort((a,b) => a.confidence - b.confidence);
            } else {
              return doc.sort((a,b) => a.updatedAt - b.updatedAt);
            }
          },
          getUploadList(){
            let upload = []
            for (let i of this.projectDatasets){
              
              upload.push({id: i.id, filename: i.filename})
            }
            
            return upload
          },
          getDocuments(){
              
            return this.sortDocuments(
              this.fuzzySearchFilter(
                this.rows.filter( 
                  item => (
                    this.givenFilter(item) && this.predictedFilter(item) && this.searchFilter(item) && this.datasetFilter(item)
                  )
                )
              )
            )
          },
          fetchDocuments(){
            this.documents = this.getDocuments()
            this.uploadList = this.getUploadList()
            this.isMounting = false
            this.isLoading = false
            
          }
         },
          mounted() {
              
              this.isMounting = false
              this.isLoading = false
  
         }, created() {
  
         }
       };
  </script>
  <style lang="scss" scoped>
  
  .vertical {
    height: 500px;/*Altura da linha*/
    border-left: 2px solid;/* Adiciona borda esquerda na div como ser fosse uma linha.*/
  }
    .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;
    &:hover {
    background: #fafafa;
    }
    .info {
    padding: 16px;
    .name {
    display: block;
    margin-bottom: 8px;
    text-transform: capitalize;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    }
    .description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
    margin-bottom: 8px;
    overflow: hidden;
    }
    }
    }
    }
  
  
  
  
  </style>